import React from 'react';
import { observer } from 'mobx-react';
import LeadDetails from '@/pages/leads/LeadDetails';
import PotentialDetails from '@/pages/potentials/PotentialDetails';
import OrderDetails from '@/pages/orders/OrderDetails';
import store from './store';

@observer
export default class IdDetailDialog extends React.PureComponent {
  constructor(p) {
    super(p);
    this.state = {
      hide: false,
    };
  }

  handleHide() {
    store.changeIdDialogInfo({});
  }

  render() {
    const { showIdDialogInfo } = store;
    const {
      type,
      id,
    } = showIdDialogInfo;

    if (type === 'leads') {
      return <LeadDetails id={id} handleClose={this.handleHide}/>;
    }
    if (type === 'potentials') {
      return <PotentialDetails id={id} handleClose={this.handleHide}/>;
    }
    if (type === 'orders') {
      return <OrderDetails id={id} handleClose={this.handleHide}/>;
    }
    return <div/>;
  }
}

